import { useState } from "react";
import AssignmentMarkTable from "../../components/AssignmentMark/AssignmentMarkTable";
import FilterComponent from "../../components/AssignmentMark/FilterComponent";
import Error from "../../components/ui/Error";
import NotFound from "../../components/ui/NotFound";
import { usePageTitle } from "../../hooks/usePageTitle";
import TableLoader from "../../Loader/admin/TableLoader";
import { useGetAssignmentMarkQuery } from "../../redux/features/assignment/assignmentApi";


export default function AssignmentMark() {
    usePageTitle(`Assignment Mark`);
    const { data: assignmentMark, isLoading, isError } = useGetAssignmentMarkQuery()
    const [filter, setFilter] = useState(false)


    //  decide what to render
    let content = null;
    let filterContent = null;
    if (isLoading) {
        content = <TableLoader />;
        filterContent = <TableLoader />;
    }
    else if (!isLoading && isError) {
        content = <Error message={"There was an error occurred"} isPadding={true} />
    }
    else if (!isLoading && !isError && !assignmentMark?.length) {
        content = <NotFound isPadding={true} />
    }
    else if (!isLoading && !isError && assignmentMark?.length) {

        const filteredContent = assignmentMark.filter(item => filter ? item.status === filter : true)

        content = <AssignmentMarkTable assignmentMark={filteredContent} />

        filterContent = <FilterComponent setFilter={setFilter} assignmentMark={assignmentMark} />
    }
    return (
        <section className="py-6 bg-primary">
            <div className="mx-auto max-w-full px-5 lg:px-20">
                <div className="px-3 py-20 bg-opacity-10">
                    {filterContent}
                    <div className="overflow-x-auto mt-4">
                        {content}
                    </div>
                </div>
            </div>
        </section>
    )
};